import { render, staticRenderFns } from "./DetailsOfSection.vue?vue&type=template&id=be26943e&scoped=true&"
import script from "./DetailsOfSection.vue?vue&type=script&lang=js&"
export * from "./DetailsOfSection.vue?vue&type=script&lang=js&"
import style0 from "./DetailsOfSection.vue?vue&type=style&index=0&id=be26943e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be26943e",
  null
  
)

export default component.exports